import {
  Devices,
  Folder,
  History,
  Link,
  // RoomPreferences,
  SportsEsports,
} from "@mui/icons-material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import { UsersIcon } from "ui";

import {
  NAVIGATION_NAME,
  NavigationCluster,
} from "../../interfaces/Navigation";

export const NAVIGATOR = {
  home: "/home",
  devices: "/devices",
  registerPlayer: "/register_player",
  scores: "/scores",
  matches: "/matches",
  signIn: "/sign-in",
  updatePassword: "/update-password",
  resetPassword: "/reset-password",
  resetPasswordInstructionsSent: "/reset-password-instructions-sent",
  resetPasswordError: "/reset-password-error",
  users: "/users",
  createUser: "/users/add",
  editUser: "/users/edit",
  link: "/link",
  configs: "/configs",
  sessions: "/sessions",
  documentation: "/documentation",
};

export const roleBasedRoutes: NavigationCluster = {
  ADMIN: [
    {
      name: NAVIGATION_NAME.HOME,
      href: NAVIGATOR.home,
      icon: PlayCircleIcon,
    },
    {
      name: NAVIGATION_NAME.SESSION,
      href: NAVIGATOR.sessions,
      icon: SportsEsports,
    },
    {
      name: NAVIGATION_NAME.DEVICES,
      href: NAVIGATOR.devices,
      icon: Devices,
    },
    {
      name: NAVIGATION_NAME.MATCHES,
      href: NAVIGATOR.matches,
      icon: History,
    },
    {
      name: NAVIGATION_NAME.LINKS,
      href: NAVIGATOR.link,
      icon: Link,
    },
    {
      name: NAVIGATION_NAME.CONFIGS,
      href: NAVIGATOR.configs,
      icon: SettingsIcon,
    },
    {
      name: NAVIGATION_NAME.DOCUMENTATION,
      href: NAVIGATOR.documentation,
      icon: Folder,
    },
  ],
  SUPER_ADMIN: [
    {
      name: NAVIGATION_NAME.USERS,
      href: NAVIGATOR.users,
      icon: UsersIcon,
    },
  ],
};
